import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router";
import { ShareCodeService } from "../services/ShareCodeService";
import { ERROR, useNotification } from "./CustomHooks/NotificationProvider";

const allowedPaths = [
  "/rater",
  "/external-assessment",
  "/results",
  "/public/results",
  "/public/reviews",
];

const Share = () => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const { tenantId, shareId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchShareCode() {
      try {
        const sharePayload = await ShareCodeService.getExternalShareCode(
          `${tenantId}/${shareId}`,
          true
        );
        const redirectPath = sharePayload.payload.shared_path;
        if (!allowedPaths.includes(redirectPath)) {
          showNotification(
            t("notifications.shareCode.invalidSharePath"),
            ERROR
          );
          return;
        }
        if (redirectPath === "/rater") {
          const state = {
            state: {
              purl_id: sharePayload.payload.context.purl_id,
              term_id: sharePayload.payload.context.term_id,
              assessment_id: sharePayload.payload.context.assessment_id,
              assignment_id: sharePayload.payload.context.assignment_id,
              token: sharePayload.token,
              share_id: shareId,
            },
          };
          return navigate(redirectPath, state);
        } else if (redirectPath === "/external-assessment") {
          const state = {
            state: {
              purl_id: sharePayload.payload.context.purl_id,
              term_id: sharePayload.payload.context.term_id,
              assessment_id: sharePayload.payload.context.assessment_id,
              assignment_id: sharePayload.payload.context.assignment_id,
              token: sharePayload.token,
              share_id: shareId,
              assessment_type: sharePayload.payload.context.assessment_type,
            },
          };
          return navigate("/rater", state);
        } else {
          try {
            const shareCode = await ShareCodeService.getPlanShareCode(
              sharePayload.payload.context.plan_id
            );
            const state = {
              state: {
                purl_id: sharePayload.payload.context.purl_id,
                plan_id: sharePayload.payload.context.plan_id,
                share_id: shareId,
                public_share_id: shareCode.public,
              },
            };
            return navigate(redirectPath, state);
          } catch {
            const state = {
              state: {
                purl_id: sharePayload.payload.context.purl_id,
                plan_id: sharePayload.payload.context.plan_id,
                share_id: shareId,
              },
            };
            return navigate(redirectPath, state);
          }
        }
      } catch {
        showNotification(t("notifications.shareCode.getShareCodeError"), ERROR);
      }
    }

    fetchShareCode();
  }, [navigate, shareId, showNotification, tenantId]);
};

export default Share;
